// 账号管理接口
// 协作账号保存
export function accAdAgentAccountAdd(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/adAgentAccount/add',
    data
  })
}
// 协作账号编辑保存
export function accAdAgentAccountEdit(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/adAgentAccount/edit',
    data
  })
}
// 协作账号列表
export function getAccAdAgentAccountPageList(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/adAgentAccount/pageList',
    data
  })
}
// 协作账号详情
export function getAccAdAgentAccountDetail(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/adAgentAccount/data',
    data
  })
}
// 操作客户列表
export function getAccAdAgentAccountDataList(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/adDspPartner/dataList',
    data
  })
}

// 主体资质管理
// 获取当前账号的主体资质
export function getAccAdDspPartnerCurrDetail(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/adDspPartner/currentData',
    data
  })
}
// 保存主体资质
export function getAccAdDspPartnerSave(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/adDspPartner/save',
    data
  })
}

// 广告主管理
// 查询分页广告主列表
export function getAccAdDspPartnerPageList(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/adDspPartner/pageList',
    data
  })
}
// 新增保存广告主
export function getAccAdDspPartnerAdd(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/adDspPartner/add',
    data
  })
}
// 编辑保存广告主
export function getAccAdDspPartnerEdit(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/adDspPartner/edit',
    data
  })
}
// 查询单条广告主
export function getAccAdDspPartnerDetail(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/adDspPartner/data',
    data
  })
}

// 广告主账号管理
// 查询分页广告主账号列表
export function getAccAdDspCustomerPageList(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/adAgentAccount/customerPageList',
    data
  })
}
// 新增保存广告主账号
// export function accAdDspCustomerAdd(data) {
//   return this.fetch({
//     method: 'post',
//     url: 'api/dsp/adAgentAccount/add',
//     data
//   })
// }
export function accAdDspCustomerAdd(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/adAgentAccount/addCustomer',
    data
  })
}
// 编辑保存广告主账号
// export function accAdDspCustomerEdit(data) {
//   return this.fetch({
//     method: 'post',
//     url: 'api/dsp/adAgentAccount/edit',
//     data
//   })
// }
export function accAdDspCustomerEdit(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/adAgentAccount/editCustomer',
    data
  })
}
// 查询单条广告主账号
export function getAccAdDspCustomerDetail(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/adAgentAccount/data',
    data
  })
}
// 查询单条广告主账号
export function getAccAdDspCustomerDelete(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/adAgentAccount/remove',
    data
  })
}
// 查询业务列表
export function getAdAgentAccountList(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/adAgentAccount/dataList',
    data
  })
}
// 查询省份城市
export function getRegionList(data) {
  return this.fetch({
    method: 'get',
    url: 'api/dsp/base/getRegionList',
    data
  })
}
// 广告主审核
export function partnerCableApprove(data) {
  return this.fetch({
    method: 'post',
    url: 'api/admin/adDspPartnerCable/submit',
    data
  })
}

// 查询公司
export function getCrmCustomer(params) {
  return this.fetch({
    method: 'get',
    url: 'api/dsp/adDspPartner/getCrmCustomer',
    params
  })
}
